const DEFAULT_CARD_IMAGE_CONFIG = {
    width: 600,
    height: 400,
    alt: "Card image",
};

export { DEFAULT_CARD_IMAGE_CONFIG };
